export default "__VITE_ASSET__BGmog$83__$_?url__"